/**
 * @desc 分页查询
 */
import {
  PagePriceIndexCategoryEntity,
  PriceIndexCategoryPageQuery
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryPriceIndexCategoryPageParameter = PriceIndexCategoryPageQuery

const method = 'GET'
const url = '/content/priceIndexCategory/page'

export const queryPriceIndexCategoryPageApi = (
  params?: QueryPriceIndexCategoryPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PagePriceIndexCategoryEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryPriceIndexCategoryPageApi.method = method
queryPriceIndexCategoryPageApi.url = url
